/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DomainCreateRequest
 */
export interface DomainCreateRequest {
    /**
     * The domain name (e.g. hostname of the website)
     * @type {string}
     * @memberof DomainCreateRequest
     */
    name?: string;
    /**
     * The subscription billing interval for this `Domain`
     * @type {string}
     * @memberof DomainCreateRequest
     */
    interval?: DomainCreateRequestIntervalEnum;
    /**
     * The subscription expiry date for this `Domain`
     * @type {Date}
     * @memberof DomainCreateRequest
     */
    expires?: Date;
    /**
     * Whether the subscription auto-renews
     * @type {boolean}
     * @memberof DomainCreateRequest
     */
    renew?: boolean;
    /**
     * The timezone for this `Domain`
     * @type {string}
     * @memberof DomainCreateRequest
     */
    timezone?: string;
    /**
     * Whether Google Analytics tracking is enabled
     * @type {boolean}
     * @memberof DomainCreateRequest
     */
    trackGA?: boolean;
    /**
     * Whether conversion tracking is enabled
     * @type {boolean}
     * @memberof DomainCreateRequest
     */
    trackConversion?: boolean;
    /**
     * Alternative domain names that resolve to this `Domain`
     * @type {Array<string>}
     * @memberof DomainCreateRequest
     */
    aliases?: Array<string>;
    /**
     * Additional key-value properties for this `Domain`
     * @type {{ [key: string]: string; }}
     * @memberof DomainCreateRequest
     */
    properties?: { [key: string]: string; };
}


/**
 * @export
 */
export const DomainCreateRequestIntervalEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type DomainCreateRequestIntervalEnum = typeof DomainCreateRequestIntervalEnum[keyof typeof DomainCreateRequestIntervalEnum];


/**
 * Check if a given object implements the DomainCreateRequest interface.
 */
export function instanceOfDomainCreateRequest(value: object): value is DomainCreateRequest {
    return true;
}

export function DomainCreateRequestFromJSON(json: any): DomainCreateRequest {
    return DomainCreateRequestFromJSONTyped(json, false);
}

export function DomainCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'interval': json['interval'] == null ? undefined : json['interval'],
        'expires': json['expires'] == null ? undefined : (new Date(json['expires'])),
        'renew': json['renew'] == null ? undefined : json['renew'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'trackGA': json['trackGA'] == null ? undefined : json['trackGA'],
        'trackConversion': json['trackConversion'] == null ? undefined : json['trackConversion'],
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'properties': json['properties'] == null ? undefined : json['properties'],
    };
}

export function DomainCreateRequestToJSON(json: any): DomainCreateRequest {
    return DomainCreateRequestToJSONTyped(json, false);
}

export function DomainCreateRequestToJSONTyped(value?: DomainCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'interval': value['interval'],
        'expires': value['expires'] == null ? value['expires'] : value['expires'].toISOString(),
        'renew': value['renew'],
        'timezone': value['timezone'],
        'trackGA': value['trackGA'],
        'trackConversion': value['trackConversion'],
        'aliases': value['aliases'],
        'properties': value['properties'],
    };
}

